import { CouponType } from './CouponType';

export interface CouponSummary {
  id: number;
  code: string;
  name: string;
  type: CouponType;
  value: number;
  isActive: boolean;
  startAt: Date;
  endAt: Date;
  createdAt: Date;
  updatedAt: Date;
}

export const couponSummaryFromResponse = (
  responseData: any,
): CouponSummary => ({
  id: responseData.id,
  code: responseData.code,
  name: responseData.name,
  type: responseData.type,
  value: responseData.value,
  isActive: responseData.is_active,
  startAt: new Date(responseData.start_at),
  endAt: new Date(responseData.end_at),
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});
